const site = {
  brand: "odinno",
  tagline: "OnDemand Innovation",
  title: "odinno | OnDemand Innovation - Software Company",
  description:
    "Odinno (OnDemand Innovation) is a software development house and Meta technology integration partner — WhatsApp Business API, Meta Ads automation, Facebook & Instagram Cloud APIs, AI and custom software solutions.",
  keywords:
    "Odinno, OnDemand Innovation, software company, WhatsApp Business API, WhatsApp Cloud API, Meta Ads API, Meta technology partner, Facebook Cloud API, Instagram API, webhooks, web development, app development, AI, cloud, ERP, CRM, custom software, Pakistan, USA",
  author: "Odinno - OnDemand Innovation",
  email: "info@odinno.com",
  phone: "+92 315 1081018",
  whatsappLink: "https://wa.me/923151081018",
  location: "Karachi, Pakistan",
  copyrightYear: 2025,
  nav: [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Projects", href: "#projects" },
    { label: "Industries", href: "#industries" },
  ],
  socials: [
    {
      name: "whatsapp",
      label: "WhatsApp",
      href: "https://wa.me/923151081018",
    },
    {
      name: "github",
      label: "GitHub",
      href: "https://www.github.com/odinno-official",
    },
    {
      name: "linkedin",
      label: "LinkedIn",
      href: "https://www.linkedin.com/company/odinno",
    },
    {
      name: "facebook",
      label: "Facebook",
      href: "https://www.facebook.com/odinno.official",
    },
    {
      name: "instagram",
      label: "Instagram",
      href: "https://www.instagram.com/odinno.official",
    },
  ],
};

export default site;
